// extracted by mini-css-extract-plugin
module.exports = {"faqMain":"faq_faqMain__3co6w","faqText":"faq_faqText__2-W0J","borderB":"faq_borderB__1n2Rv","question":"faq_question__2Qv6F","answer":"faq_answer__14K6K","open":"faq_open__3U8CA"};